import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ModelsListComponent } from './models-list/models-list.component';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { ModelsComponent } from './models-add-upd/models-add-upd.component';

const routes: Routes = [
    { path: 'models-list', component: ModelsListComponent, canActivate: [AuthGuard] },
    { path: 'models', component: ModelsComponent, canActivate: [AuthGuard] }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class ModelsRoutingModule { }
